var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.84004 0 7.72671 0.54 7.00004 1.39333C6.27337 0.54 5.16004 0 4.00004 0C1.94671 0 0.333374 1.61333 0.333374 3.66667C0.333374 6.18667 2.60004 8.24 6.03337 11.36L7.00004 12.2333L7.96671 11.3533C11.4 8.24 13.6667 6.18667 13.6667 3.66667C13.6667 1.61333 12.0534 0 10 0ZM7.06671 10.3667L7.00004 10.4333L6.93337 10.3667C3.76004 7.49333 1.66671 5.59333 1.66671 3.66667C1.66671 2.33333 2.66671 1.33333 4.00004 1.33333C5.02671 1.33333 6.02671 1.99333 6.38004 2.90667H7.62671C7.97337 1.99333 8.97337 1.33333 10 1.33333C11.3334 1.33333 12.3334 2.33333 12.3334 3.66667C12.3334 5.59333 10.24 7.49333 7.06671 10.3667Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutlined);
export default __webpack_public_path__ + "static/media/heartOutlined.103dbfae.svg";
export { ForwardRef as ReactComponent };